import { render, staticRenderFns } from "./GerarDemonstrativoDialog.vue?vue&type=template&id=4b18333a&"
import script from "./GerarDemonstrativoDialog.vue?vue&type=script&lang=js&"
export * from "./GerarDemonstrativoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports